export const REQUEST_TYPES = Object.freeze({
  1: 'PRODUCT PASSWORD RESET',
  2: 'KYC UPLOAD',
  3: 'Google Authenticator'
});

export const REQUEST_STATUS = Object.freeze({
  1: 'Requested',
  2: 'Processed',
  3: 'Declined',
  4: 'Acknowledged'
});

export class MemberRequestForm {
    constructor() {
      this.requestFrom = null;
      this.requestTo = null;
      this.requestTypes = null;
      this.requestStatus = null;
      this.limit = null;
      this.page = null;
      this.orderBy = null;
      this.precision = null;
      this.sort = null;

      this.types = [];
      this.setTypes();
    }

    toPayload() {
      return {
        from: this.requestFrom,
        to: this.requestTo,
        types: this.requestTypes,
        status: this.requestStatus,
        limit: this.limit,
        page: this.page
      }
    }

    setTypes() {
      for (let key in REQUEST_TYPES) {
        this.types.push({
          value: key,
          text: REQUEST_TYPES[key]
        });
      }
    }

    reset() {
      this.requestFrom = null;
      this.requestTo = null;
      this.requestTypes = null;
      this.requestStatus = null;
      this.limit = null;
      this.page = null;
      this.orderBy = null;
      this.precision = null;
      this.sort = null;
    }
  };
  
  export default MemberRequestForm;
  


// WEBPACK FOOTER //
// ./client/app/pages/requests/model/form.model.js